// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1E-dw","newExpiryDate":"styles_newExpiryDate__1z3gE","footer":"styles_footer__yeOzN"};